const element = document.getElementById('mascot-container');
const img = element.querySelector('img');
const actualSrc = img.getAttribute('data-src');

function moveElementRandomly() {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const elementWidth = element.offsetWidth;
  const elementHeight = element.offsetHeight;

  const maxX = viewportWidth - elementWidth;
  const maxY = viewportHeight - elementHeight;

  const randomX = Math.random() * maxX;
  const randomY = Math.random() * maxY;

  element.style.left = `${randomX}px`;
  element.style.top = `${randomY}px`;
}

function activateClassRandomly() {
  const delay = Math.random() * 10000 + 10000;

  setTimeout(() => {
    img.src = '';
    img.src = actualSrc;
    moveElementRandomly();
    element.classList.add('active');

    setTimeout(() => {
      element.classList.remove('active');
      activateClassRandomly();
    }, 3500);
  }, delay);
}

activateClassRandomly();